import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import desktopImg from "assets/desktop.png";
import { ReactComponent as Logo } from "components/Icons/logoBlack.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React from "react";
import { Link } from "react-router-dom";
import { links } from "utilities/links";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formContainer: {
      backgroundColor: theme.white00,
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    imageContainer: {
      backgroundColor: theme.primary700,
      minHeight: "100vh",
      padding: theme.spacing(28, 0, 0, 20),
      display: "flex",
      flexDirection: "column",
    },
    formWrapper: {
      width: "100%",
      maxWidth: "438px",
      margin: "0 auto",
    },
    testimony: {
      fontSize: 20,
      fontWeight: 500,
      lineHeight: "32px",
      color: theme.gray50,
      paddingRight: theme.spacing(20),
      display: "flex",
      alignItems: "center",
    },
    img: {
      marginTop: "auto",
      paddingTop: theme.spacing(16),
    },
    logo: {
      position: "fixed",
      top: "34px",
      left: "42px",
    },
    line: {
      width: 20,
      height: 2,
      background: theme.white00,
      marginRight: theme.spacing(5),
      display: "inline-block",
    },
  }),
);
type Props = {
  children?: React.ReactNode;
};
export function FormLayout({ children }: Props) {
  const classes = useStyles();

  return (
    <Grid
      alignItems="center"
      className={classes.formContainer}
      container
      justifyContent="center"
      spacing={0}
    >
      <Grid item xs={6}>
        <div className={classes.formWrapper}>
          <Link to={links.homepage}>
            <Logo className={classes.logo} />
          </Link>
          {children}
        </div>
      </Grid>
      <Grid item xs={6} className={classes.imageContainer}>
        <Typography className={classes.testimony}>
          “The Open Loyalty customer loyalty program software allows us a lot of
          flexibility in building these dynamics and delivering a strong
          experience for our consumers”
        </Typography>
        <Typography mt={6} className={classes.testimony}>
          <div className={classes.line} /> Thomas Archer Bata
        </Typography>
        <Typography className={classes.testimony}>ALDO Group</Typography>
        <img src={desktopImg} alt="desktop" className={classes.img} />
      </Grid>
    </Grid>
  );
}
